<template>
  <el-dialog
    title="沟通记录"
    :visible.sync="show"
    width="960px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="communicate-record-dialog"
  >
    <el-table
      border
      stripe
      :data="tableData"
      v-loading="isLoading"
      height="calc(90vh - 200px)"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column label="可下单量" min-width="140">
        <template slot-scope="{ row }">
          <div class="change-cell">
            <div>变更前：{{ row.orderableQtyBefore }}</div>
            <div v-if="row.orderableQtyAfter" class="after">变更后：{{ row.orderableQtyAfter }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="佣金" min-width="160">
        <template slot-scope="{ row }">
          <div class="change-cell">
            <div>变更前：{{ row.commissionBefore }}</div>
            <div v-if="row.commissionAfter" class="after">变更后：{{ row.commissionAfter }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="预期下单时间" min-width="180">
        <template slot-scope="{ row }">
          <div class="change-cell">
            <div>变更前：{{ row.expectedOrderTimeBefore }}</div>
            <div v-if="row.expectedOrderTimeAfter" class="after">变更后：{{ row.expectedOrderTimeAfter }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="200">
        <template slot-scope="{ row }">
          <div class="remark-cell">{{ row.remark }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="changeTime" label="变更时间" min-width="160" />
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-pagination
        v-if="pageInfo.total > 0"
        background
        layout="prev, pager, next, jumper"
        :total="pageInfo.total"
        :page-size="pageInfo.size"
        :current-page="pageInfo.current"
        @current-change="handlePageChange"
      />
      <el-button @click="show = false">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getQdVolumeChangeLogPage, getBizVolumeChangeLogPage } from '@/service/apis/supVolume'
import { formatChangeLogItem } from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'ReserveRecordCommunicateDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    },
    source: {
      type: String,
      default: 'qd'
    }
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      pageInfo: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.pageInfo.current = 1
        this.getList()
      }
    }
  },
  methods: {
    getList() {
      if (!this.record || !this.record.id) {
        this.tableData = []
        this.pageInfo.total = 0
        return
      }
      this.isLoading = true
      const fetchApi = this.source === 'biz' ? getBizVolumeChangeLogPage : getQdVolumeChangeLogPage
      fetchApi.call(this, {
        reservationId: this.record.id,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then(res => {
        const records = res.records || []
        this.pageInfo.total = res.total || 0
        this.tableData = records
          .map(formatChangeLogItem)
          .sort((a, b) => new Date(b.changeTime).getTime() - new Date(a.changeTime).getTime())
      }).finally(() => {
        this.isLoading = false
      })
    },
    handlePageChange(page) {
      this.pageInfo.current = page
      this.getList()
    }
  }
}
</script>

<style scoped>
.change-cell {
  line-height: 22px;
  font-size: 12px;
  color: #333;
}

.change-cell .after {
  color: #f5222d;
}

.remark-cell {
  line-height: 20px;
  font-size: 12px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

<style>
.communicate-record-dialog {
  margin-top: 5vh !important;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.communicate-record-dialog .el-dialog__header {
  flex-shrink: 0;
}

.communicate-record-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px 20px;
}

.communicate-record-dialog .el-dialog__footer {
  flex-shrink: 0;
}
</style>
